var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKipa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.931,
    height: 48.808,
    viewBox: "0 0 53.931 48.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1154",
    x: 0,
    y: 0,
    width: 53.931,
    height: 48.808,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.541
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(17.133 7) rotate(34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.83, -0.56, 0.56, 0.83, -18.12, 3.78)",
    filter: "url(#Path_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154-2",
    "data-name": "Path 1154",
    d: "M33.531,10.8a41.7,41.7,0,0,1-16.765,3.741A41.7,41.7,0,0,1,0,10.8S7.4,0,16.662,0,33.531,10.8,33.531,10.8Z",
    transform: "translate(17.13 7) rotate(34)",
    fill: "#00609e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M16.765,3.207A42.1,42.1,0,0,1,1.195,0C.424.94,0,1.559,0,1.559A41.7,41.7,0,0,0,16.765,5.3,41.7,41.7,0,0,0,33.531,1.558S33.1.944,32.314.009A42.1,42.1,0,0,1,16.765,3.207Z",
    transform: "translate(0 9.245)",
    fill: "#1fb6c0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(12.367 1.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M7.02,4.95,8.353,2.617l-2.674.012L4.162,0,2.636,2.643.029,2.655,1.336,4.894,0,7.209H2.687L4.224,9.844,5.73,7.209H8.324Zm.569-1.888L6.764,4.507l-.521-.9L5.934,3.07ZM6.509,4.952,5.473,6.766H2.941L1.848,4.893,2.892,3.084l2.532-.012ZM4.162.885,5.17,2.631l-.978,0-1.043,0ZM.8,3.094,2.38,3.086l-.3.518-.49.848ZM.766,6.766l.827-1.432.835,1.432ZM4.22,8.959,3.2,7.209H5.22ZM6.289,6.23,6.766,5.4l.791,1.371H5.983Z",
    transform: "translate(0 0)",
    fill: "#f8ecac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M2.516,6.766H0L1.251,4.6.03,2.506l2.436-.011L3.907,0,5.339,2.481l2.5-.011L6.594,4.656l1.219,2.11H5.389L3.967,9.254Zm1.45,2.193L5.219,6.766H2.687Zm1.507-2.34H7.557L6.51,4.8ZM2.552,2.642,1.422,4.6,2.6,6.619H5.3L6.424,4.656,5.254,2.63ZM.256,6.619H2.43L1.337,4.746Zm5.169-3.99L6.509,4.508,7.588,2.619ZM.287,2.652l1.049,1.8L2.381,2.643Zm2.351-.158,2.532-.012L3.907.3Z",
    transform: "translate(0.256 0.295)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M21.294,14.258a12.813,12.813,0,0,0,2.97-8.109,12.3,12.3,0,0,0-.784-4.318A14.787,14.787,0,0,0,16.662,0C7.4,0,0,10.8,0,10.8a41.7,41.7,0,0,0,16.765,3.741A36.858,36.858,0,0,0,21.294,14.258Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 2.142,
    cy: 0.714,
    rx: 2.142,
    ry: 0.714,
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 9.079, 2.862)",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKipa);
export default __webpack_public_path__ + "static/media/kipa.5f0278232d0742095d5509a072d00b94.svg";
export { ForwardRef as ReactComponent };